import { render, staticRenderFns } from "./EventHistoryTableTab.vue?vue&type=template&id=760c1442&scoped=true&"
import script from "./EventHistoryTableTab.vue?vue&type=script&lang=ts&"
export * from "./EventHistoryTableTab.vue?vue&type=script&lang=ts&"
import style0 from "./EventHistoryTableTab.vue?vue&type=style&index=0&id=760c1442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c1442",
  null
  
)

export default component.exports